// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 216 ? "d83d1942" : chunkId) + "." + {"216":"b91ea69fa424f525","993":"3ae9b2907bb92a84"}[chunkId] + ".js";
};